import { api } from '../../../App';
import { fromPhoneToGenerated } from '../../../parsers/to-generated/phoneNumber.parser';
import { RequestType } from '../../../model/enums/RequestType';

export const enrollForVisit = async (type: RequestType, phone: string, token: string) => {
  const phoneNumberDto = fromPhoneToGenerated(phone);

  if (type === RequestType.PatientRegistration) {
    await api.enrollment.apiEnrollPatientPost(token, phoneNumberDto);
  } else if (type === RequestType.DoctorRegistration) {
    await api.enrollment.apiEnrollDoctorPost(token, phoneNumberDto);
  }
};
